"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_REGIONS = void 0;
/**
 * AUTO-GENERATED FILE.
 *
 * Generated from Shopify countries/provinces JSON via scripts/generateCountryRegions.ts
 * Do not edit manually.
 */
exports.COUNTRY_REGIONS = {
    "AU": [
        {
            "code": "ACT",
            "name": "Australian Capital Territory",
            "taxRate": 0
        },
        {
            "code": "NSW",
            "name": "New South Wales",
            "taxRate": 0
        },
        {
            "code": "NT",
            "name": "Northern Territory",
            "taxRate": 0
        },
        {
            "code": "QLD",
            "name": "Queensland",
            "taxRate": 0
        },
        {
            "code": "SA",
            "name": "South Australia",
            "taxRate": 0
        },
        {
            "code": "TAS",
            "name": "Tasmania",
            "taxRate": 0
        },
        {
            "code": "VIC",
            "name": "Victoria",
            "taxRate": 0
        },
        {
            "code": "WA",
            "name": "Western Australia",
            "taxRate": 0
        }
    ],
    "CA": [
        {
            "code": "AB",
            "name": "Alberta",
            "taxRate": 0
        },
        {
            "code": "BC",
            "name": "British Columbia",
            "taxRate": 0
        },
        {
            "code": "MB",
            "name": "Manitoba",
            "taxRate": 0
        },
        {
            "code": "NB",
            "name": "New Brunswick",
            "taxRate": 0
        },
        {
            "code": "NL",
            "name": "Newfoundland and Labrador",
            "taxRate": 0
        },
        {
            "code": "NT",
            "name": "Northwest Territories",
            "taxRate": 0
        },
        {
            "code": "NS",
            "name": "Nova Scotia",
            "taxRate": 0
        },
        {
            "code": "NU",
            "name": "Nunavut",
            "taxRate": 0
        },
        {
            "code": "ON",
            "name": "Ontario",
            "taxRate": 0
        },
        {
            "code": "PE",
            "name": "Prince Edward Island",
            "taxRate": 0
        },
        {
            "code": "QC",
            "name": "Quebec",
            "taxRate": 0
        },
        {
            "code": "SK",
            "name": "Saskatchewan",
            "taxRate": 0
        },
        {
            "code": "YT",
            "name": "Yukon",
            "taxRate": 0
        }
    ],
    "EG": [
        {
            "code": "SU",
            "name": "6th of October",
            "taxRate": 0
        },
        {
            "code": "SHR",
            "name": "Al Sharqia",
            "taxRate": 0
        },
        {
            "code": "ALX",
            "name": "Alexandria",
            "taxRate": 0
        },
        {
            "code": "ASN",
            "name": "Aswan",
            "taxRate": 0
        },
        {
            "code": "AST",
            "name": "Asyut",
            "taxRate": 0
        },
        {
            "code": "BH",
            "name": "Beheira",
            "taxRate": 0
        },
        {
            "code": "BNS",
            "name": "Beni Suef",
            "taxRate": 0
        },
        {
            "code": "C",
            "name": "Cairo",
            "taxRate": 0
        },
        {
            "code": "DK",
            "name": "Dakahlia",
            "taxRate": 0
        },
        {
            "code": "DT",
            "name": "Damietta",
            "taxRate": 0
        },
        {
            "code": "FYM",
            "name": "Faiyum",
            "taxRate": 0
        },
        {
            "code": "GH",
            "name": "Gharbia",
            "taxRate": 0
        },
        {
            "code": "GZ",
            "name": "Giza",
            "taxRate": 0
        },
        {
            "code": "HU",
            "name": "Helwan",
            "taxRate": 0
        },
        {
            "code": "IS",
            "name": "Ismailia",
            "taxRate": 0
        },
        {
            "code": "KFS",
            "name": "Kafr el-Sheikh",
            "taxRate": 0
        },
        {
            "code": "LX",
            "name": "Luxor",
            "taxRate": 0
        },
        {
            "code": "MT",
            "name": "Matrouh",
            "taxRate": 0
        },
        {
            "code": "MN",
            "name": "Minya",
            "taxRate": 0
        },
        {
            "code": "MNF",
            "name": "Monufia",
            "taxRate": 0
        },
        {
            "code": "WAD",
            "name": "New Valley",
            "taxRate": 0
        },
        {
            "code": "SIN",
            "name": "North Sinai",
            "taxRate": 0
        },
        {
            "code": "PTS",
            "name": "Port Said",
            "taxRate": 0
        },
        {
            "code": "KB",
            "name": "Qalyubia",
            "taxRate": 0
        },
        {
            "code": "KN",
            "name": "Qena",
            "taxRate": 0
        },
        {
            "code": "BA",
            "name": "Red Sea",
            "taxRate": 0
        },
        {
            "code": "SHG",
            "name": "Sohag",
            "taxRate": 0
        },
        {
            "code": "JS",
            "name": "South Sinai",
            "taxRate": 0
        },
        {
            "code": "SUZ",
            "name": "Suez",
            "taxRate": 0
        }
    ],
    "HK": [
        {
            "code": "HK",
            "name": "Hong Kong Island",
            "taxRate": 0
        },
        {
            "code": "KL",
            "name": "Kowloon",
            "taxRate": 0
        },
        {
            "code": "NT",
            "name": "New Territories",
            "taxRate": 0
        }
    ],
    "IN": [
        {
            "code": "AN",
            "name": "Andaman and Nicobar Islands",
            "taxRate": 0
        },
        {
            "code": "AP",
            "name": "Andhra Pradesh",
            "taxRate": 0
        },
        {
            "code": "AR",
            "name": "Arunachal Pradesh",
            "taxRate": 0
        },
        {
            "code": "AS",
            "name": "Assam",
            "taxRate": 0
        },
        {
            "code": "BR",
            "name": "Bihar",
            "taxRate": 0
        },
        {
            "code": "CH",
            "name": "Chandigarh",
            "taxRate": 0
        },
        {
            "code": "CG",
            "name": "Chhattisgarh",
            "taxRate": 0
        },
        {
            "code": "DN",
            "name": "Dadra and Nagar Haveli",
            "taxRate": 0
        },
        {
            "code": "DD",
            "name": "Daman and Diu",
            "taxRate": 0
        },
        {
            "code": "DL",
            "name": "Delhi",
            "taxRate": 0
        },
        {
            "code": "GA",
            "name": "Goa",
            "taxRate": 0
        },
        {
            "code": "GJ",
            "name": "Gujarat",
            "taxRate": 0
        },
        {
            "code": "HR",
            "name": "Haryana",
            "taxRate": 0
        },
        {
            "code": "HP",
            "name": "Himachal Pradesh",
            "taxRate": 0
        },
        {
            "code": "JK",
            "name": "Jammu and Kashmir",
            "taxRate": 0
        },
        {
            "code": "JH",
            "name": "Jharkhand",
            "taxRate": 0
        },
        {
            "code": "KA",
            "name": "Karnataka",
            "taxRate": 0
        },
        {
            "code": "KL",
            "name": "Kerala",
            "taxRate": 0
        },
        {
            "code": "LA",
            "name": "Ladakh",
            "taxRate": 0
        },
        {
            "code": "LD",
            "name": "Lakshadweep",
            "taxRate": 0
        },
        {
            "code": "MP",
            "name": "Madhya Pradesh",
            "taxRate": 0
        },
        {
            "code": "MH",
            "name": "Maharashtra",
            "taxRate": 0
        },
        {
            "code": "MN",
            "name": "Manipur",
            "taxRate": 0
        },
        {
            "code": "ML",
            "name": "Meghalaya",
            "taxRate": 0
        },
        {
            "code": "MZ",
            "name": "Mizoram",
            "taxRate": 0
        },
        {
            "code": "NL",
            "name": "Nagaland",
            "taxRate": 0
        },
        {
            "code": "OR",
            "name": "Odisha",
            "taxRate": 0
        },
        {
            "code": "PY",
            "name": "Puducherry",
            "taxRate": 0
        },
        {
            "code": "PB",
            "name": "Punjab",
            "taxRate": 0
        },
        {
            "code": "RJ",
            "name": "Rajasthan",
            "taxRate": 0
        },
        {
            "code": "SK",
            "name": "Sikkim",
            "taxRate": 0
        },
        {
            "code": "TN",
            "name": "Tamil Nadu",
            "taxRate": 0
        },
        {
            "code": "TS",
            "name": "Telangana",
            "taxRate": 0
        },
        {
            "code": "TR",
            "name": "Tripura",
            "taxRate": 0
        },
        {
            "code": "UP",
            "name": "Uttar Pradesh",
            "taxRate": 0
        },
        {
            "code": "UK",
            "name": "Uttarakhand",
            "taxRate": 0
        },
        {
            "code": "WB",
            "name": "West Bengal",
            "taxRate": 0
        }
    ],
    "IE": [
        {
            "code": "CW",
            "name": "Carlow",
            "taxRate": 0
        },
        {
            "code": "CN",
            "name": "Cavan",
            "taxRate": 0
        },
        {
            "code": "CE",
            "name": "Clare",
            "taxRate": 0
        },
        {
            "code": "CO",
            "name": "Cork",
            "taxRate": 0
        },
        {
            "code": "DL",
            "name": "Donegal",
            "taxRate": 0
        },
        {
            "code": "D",
            "name": "Dublin",
            "taxRate": 0
        },
        {
            "code": "G",
            "name": "Galway",
            "taxRate": 0
        },
        {
            "code": "KY",
            "name": "Kerry",
            "taxRate": 0
        },
        {
            "code": "KE",
            "name": "Kildare",
            "taxRate": 0
        },
        {
            "code": "KK",
            "name": "Kilkenny",
            "taxRate": 0
        },
        {
            "code": "LS",
            "name": "Laois",
            "taxRate": 0
        },
        {
            "code": "LM",
            "name": "Leitrim",
            "taxRate": 0
        },
        {
            "code": "LK",
            "name": "Limerick",
            "taxRate": 0
        },
        {
            "code": "LD",
            "name": "Longford",
            "taxRate": 0
        },
        {
            "code": "LH",
            "name": "Louth",
            "taxRate": 0
        },
        {
            "code": "MO",
            "name": "Mayo",
            "taxRate": 0
        },
        {
            "code": "MH",
            "name": "Meath",
            "taxRate": 0
        },
        {
            "code": "MN",
            "name": "Monaghan",
            "taxRate": 0
        },
        {
            "code": "OY",
            "name": "Offaly",
            "taxRate": 0
        },
        {
            "code": "RN",
            "name": "Roscommon",
            "taxRate": 0
        },
        {
            "code": "SO",
            "name": "Sligo",
            "taxRate": 0
        },
        {
            "code": "TA",
            "name": "Tipperary",
            "taxRate": 0
        },
        {
            "code": "WD",
            "name": "Waterford",
            "taxRate": 0
        },
        {
            "code": "WH",
            "name": "Westmeath",
            "taxRate": 0
        },
        {
            "code": "WX",
            "name": "Wexford",
            "taxRate": 0
        },
        {
            "code": "WW",
            "name": "Wicklow",
            "taxRate": 0
        }
    ],
    "IT": [
        {
            "code": "AG",
            "name": "Agrigento",
            "taxRate": 0
        },
        {
            "code": "AL",
            "name": "Alessandria",
            "taxRate": 0
        },
        {
            "code": "AN",
            "name": "Ancona",
            "taxRate": 0
        },
        {
            "code": "AO",
            "name": "Aosta",
            "taxRate": 0
        },
        {
            "code": "AR",
            "name": "Arezzo",
            "taxRate": 0
        },
        {
            "code": "AP",
            "name": "Ascoli Piceno",
            "taxRate": 0
        },
        {
            "code": "AT",
            "name": "Asti",
            "taxRate": 0
        },
        {
            "code": "AV",
            "name": "Avellino",
            "taxRate": 0
        },
        {
            "code": "BA",
            "name": "Bari",
            "taxRate": 0
        },
        {
            "code": "BT",
            "name": "Barletta-Andria-Trani",
            "taxRate": 0
        },
        {
            "code": "BL",
            "name": "Belluno",
            "taxRate": 0
        },
        {
            "code": "BN",
            "name": "Benevento",
            "taxRate": 0
        },
        {
            "code": "BG",
            "name": "Bergamo",
            "taxRate": 0
        },
        {
            "code": "BI",
            "name": "Biella",
            "taxRate": 0
        },
        {
            "code": "BO",
            "name": "Bologna",
            "taxRate": 0
        },
        {
            "code": "BZ",
            "name": "Bolzano",
            "taxRate": 0
        },
        {
            "code": "BS",
            "name": "Brescia",
            "taxRate": 0
        },
        {
            "code": "BR",
            "name": "Brindisi",
            "taxRate": 0
        },
        {
            "code": "CA",
            "name": "Cagliari",
            "taxRate": 0
        },
        {
            "code": "CL",
            "name": "Caltanissetta",
            "taxRate": 0
        },
        {
            "code": "CB",
            "name": "Campobasso",
            "taxRate": 0
        },
        {
            "code": "CI",
            "name": "Carbonia-Iglesias",
            "taxRate": 0
        },
        {
            "code": "CE",
            "name": "Caserta",
            "taxRate": 0
        },
        {
            "code": "CT",
            "name": "Catania",
            "taxRate": 0
        },
        {
            "code": "CZ",
            "name": "Catanzaro",
            "taxRate": 0
        },
        {
            "code": "CH",
            "name": "Chieti",
            "taxRate": 0
        },
        {
            "code": "CO",
            "name": "Como",
            "taxRate": 0
        },
        {
            "code": "CS",
            "name": "Cosenza",
            "taxRate": 0
        },
        {
            "code": "CR",
            "name": "Cremona",
            "taxRate": 0
        },
        {
            "code": "KR",
            "name": "Crotone",
            "taxRate": 0
        },
        {
            "code": "CN",
            "name": "Cuneo",
            "taxRate": 0
        },
        {
            "code": "EN",
            "name": "Enna",
            "taxRate": 0
        },
        {
            "code": "FM",
            "name": "Fermo",
            "taxRate": 0
        },
        {
            "code": "FE",
            "name": "Ferrara",
            "taxRate": 0
        },
        {
            "code": "FI",
            "name": "Firenze",
            "taxRate": 0
        },
        {
            "code": "FG",
            "name": "Foggia",
            "taxRate": 0
        },
        {
            "code": "FC",
            "name": "Forlì-Cesena",
            "taxRate": 0
        },
        {
            "code": "FR",
            "name": "Frosinone",
            "taxRate": 0
        },
        {
            "code": "GE",
            "name": "Genova",
            "taxRate": 0
        },
        {
            "code": "GO",
            "name": "Gorizia",
            "taxRate": 0
        },
        {
            "code": "GR",
            "name": "Grosseto",
            "taxRate": 0
        },
        {
            "code": "IM",
            "name": "Imperia",
            "taxRate": 0
        },
        {
            "code": "IS",
            "name": "Isernia",
            "taxRate": 0
        },
        {
            "code": "AQ",
            "name": "L'Aquila",
            "taxRate": 0
        },
        {
            "code": "SP",
            "name": "La Spezia",
            "taxRate": 0
        },
        {
            "code": "LT",
            "name": "Latina",
            "taxRate": 0
        },
        {
            "code": "LE",
            "name": "Lecce",
            "taxRate": 0
        },
        {
            "code": "LC",
            "name": "Lecco",
            "taxRate": 0
        },
        {
            "code": "LI",
            "name": "Livorno",
            "taxRate": 0
        },
        {
            "code": "LO",
            "name": "Lodi",
            "taxRate": 0
        },
        {
            "code": "LU",
            "name": "Lucca",
            "taxRate": 0
        },
        {
            "code": "MC",
            "name": "Macerata",
            "taxRate": 0
        },
        {
            "code": "MN",
            "name": "Mantova",
            "taxRate": 0
        },
        {
            "code": "MS",
            "name": "Massa-Carrara",
            "taxRate": 0
        },
        {
            "code": "MT",
            "name": "Matera",
            "taxRate": 0
        },
        {
            "code": "VS",
            "name": "Medio Campidano",
            "taxRate": 0
        },
        {
            "code": "ME",
            "name": "Messina",
            "taxRate": 0
        },
        {
            "code": "MI",
            "name": "Milano",
            "taxRate": 0
        },
        {
            "code": "MO",
            "name": "Modena",
            "taxRate": 0
        },
        {
            "code": "MB",
            "name": "Monza e Brianza",
            "taxRate": 0
        },
        {
            "code": "NA",
            "name": "Napoli",
            "taxRate": 0
        },
        {
            "code": "NO",
            "name": "Novara",
            "taxRate": 0
        },
        {
            "code": "NU",
            "name": "Nuoro",
            "taxRate": 0
        },
        {
            "code": "OG",
            "name": "Ogliastra",
            "taxRate": 0
        },
        {
            "code": "OT",
            "name": "Olbia-Tempio",
            "taxRate": 0
        },
        {
            "code": "OR",
            "name": "Oristano",
            "taxRate": 0
        },
        {
            "code": "PD",
            "name": "Padova",
            "taxRate": 0
        },
        {
            "code": "PA",
            "name": "Palermo",
            "taxRate": 0
        },
        {
            "code": "PR",
            "name": "Parma",
            "taxRate": 0
        },
        {
            "code": "PV",
            "name": "Pavia",
            "taxRate": 0
        },
        {
            "code": "PG",
            "name": "Perugia",
            "taxRate": 0
        },
        {
            "code": "PU",
            "name": "Pesaro e Urbino",
            "taxRate": 0
        },
        {
            "code": "PE",
            "name": "Pescara",
            "taxRate": 0
        },
        {
            "code": "PC",
            "name": "Piacenza",
            "taxRate": 0
        },
        {
            "code": "PI",
            "name": "Pisa",
            "taxRate": 0
        },
        {
            "code": "PT",
            "name": "Pistoia",
            "taxRate": 0
        },
        {
            "code": "PN",
            "name": "Pordenone",
            "taxRate": 0
        },
        {
            "code": "PZ",
            "name": "Potenza",
            "taxRate": 0
        },
        {
            "code": "PO",
            "name": "Prato",
            "taxRate": 0
        },
        {
            "code": "RG",
            "name": "Ragusa",
            "taxRate": 0
        },
        {
            "code": "RA",
            "name": "Ravenna",
            "taxRate": 0
        },
        {
            "code": "RC",
            "name": "Reggio Calabria",
            "taxRate": 0
        },
        {
            "code": "RE",
            "name": "Reggio Emilia",
            "taxRate": 0
        },
        {
            "code": "RI",
            "name": "Rieti",
            "taxRate": 0
        },
        {
            "code": "RN",
            "name": "Rimini",
            "taxRate": 0
        },
        {
            "code": "RM",
            "name": "Roma",
            "taxRate": 0
        },
        {
            "code": "RO",
            "name": "Rovigo",
            "taxRate": 0
        },
        {
            "code": "SA",
            "name": "Salerno",
            "taxRate": 0
        },
        {
            "code": "SS",
            "name": "Sassari",
            "taxRate": 0
        },
        {
            "code": "SV",
            "name": "Savona",
            "taxRate": 0
        },
        {
            "code": "SI",
            "name": "Siena",
            "taxRate": 0
        },
        {
            "code": "SR",
            "name": "Siracusa",
            "taxRate": 0
        },
        {
            "code": "SO",
            "name": "Sondrio",
            "taxRate": 0
        },
        {
            "code": "TA",
            "name": "Taranto",
            "taxRate": 0
        },
        {
            "code": "TE",
            "name": "Teramo",
            "taxRate": 0
        },
        {
            "code": "TR",
            "name": "Terni",
            "taxRate": 0
        },
        {
            "code": "TO",
            "name": "Torino",
            "taxRate": 0
        },
        {
            "code": "TP",
            "name": "Trapani",
            "taxRate": 0
        },
        {
            "code": "TN",
            "name": "Trento",
            "taxRate": 0
        },
        {
            "code": "TV",
            "name": "Treviso",
            "taxRate": 0
        },
        {
            "code": "TS",
            "name": "Trieste",
            "taxRate": 0
        },
        {
            "code": "UD",
            "name": "Udine",
            "taxRate": 0
        },
        {
            "code": "VA",
            "name": "Varese",
            "taxRate": 0
        },
        {
            "code": "VE",
            "name": "Venezia",
            "taxRate": 0
        },
        {
            "code": "VB",
            "name": "Verbano-Cusio-Ossola",
            "taxRate": 0
        },
        {
            "code": "VC",
            "name": "Vercelli",
            "taxRate": 0
        },
        {
            "code": "VR",
            "name": "Verona",
            "taxRate": 0
        },
        {
            "code": "VV",
            "name": "Vibo Valentia",
            "taxRate": 0
        },
        {
            "code": "VI",
            "name": "Vicenza",
            "taxRate": 0
        },
        {
            "code": "VT",
            "name": "Viterbo",
            "taxRate": 0
        }
    ],
    "JP": [
        {
            "code": "JP-23",
            "name": "Aichi",
            "taxRate": 0
        },
        {
            "code": "JP-05",
            "name": "Akita",
            "taxRate": 0
        },
        {
            "code": "JP-02",
            "name": "Aomori",
            "taxRate": 0
        },
        {
            "code": "JP-12",
            "name": "Chiba",
            "taxRate": 0
        },
        {
            "code": "JP-38",
            "name": "Ehime",
            "taxRate": 0
        },
        {
            "code": "JP-18",
            "name": "Fukui",
            "taxRate": 0
        },
        {
            "code": "JP-40",
            "name": "Fukuoka",
            "taxRate": 0
        },
        {
            "code": "JP-07",
            "name": "Fukushima",
            "taxRate": 0
        },
        {
            "code": "JP-21",
            "name": "Gifu",
            "taxRate": 0
        },
        {
            "code": "JP-10",
            "name": "Gunma",
            "taxRate": 0
        },
        {
            "code": "JP-34",
            "name": "Hiroshima",
            "taxRate": 0
        },
        {
            "code": "JP-01",
            "name": "Hokkaidō",
            "taxRate": 0
        },
        {
            "code": "JP-28",
            "name": "Hyōgo",
            "taxRate": 0
        },
        {
            "code": "JP-08",
            "name": "Ibaraki",
            "taxRate": 0
        },
        {
            "code": "JP-17",
            "name": "Ishikawa",
            "taxRate": 0
        },
        {
            "code": "JP-03",
            "name": "Iwate",
            "taxRate": 0
        },
        {
            "code": "JP-37",
            "name": "Kagawa",
            "taxRate": 0
        },
        {
            "code": "JP-46",
            "name": "Kagoshima",
            "taxRate": 0
        },
        {
            "code": "JP-14",
            "name": "Kanagawa",
            "taxRate": 0
        },
        {
            "code": "JP-39",
            "name": "Kōchi",
            "taxRate": 0
        },
        {
            "code": "JP-43",
            "name": "Kumamoto",
            "taxRate": 0
        },
        {
            "code": "JP-26",
            "name": "Kyōto",
            "taxRate": 0
        },
        {
            "code": "JP-24",
            "name": "Mie",
            "taxRate": 0
        },
        {
            "code": "JP-04",
            "name": "Miyagi",
            "taxRate": 0
        },
        {
            "code": "JP-45",
            "name": "Miyazaki",
            "taxRate": 0
        },
        {
            "code": "JP-20",
            "name": "Nagano",
            "taxRate": 0
        },
        {
            "code": "JP-42",
            "name": "Nagasaki",
            "taxRate": 0
        },
        {
            "code": "JP-29",
            "name": "Nara",
            "taxRate": 0
        },
        {
            "code": "JP-15",
            "name": "Niigata",
            "taxRate": 0
        },
        {
            "code": "JP-44",
            "name": "Ōita",
            "taxRate": 0
        },
        {
            "code": "JP-33",
            "name": "Okayama",
            "taxRate": 0
        },
        {
            "code": "JP-47",
            "name": "Okinawa",
            "taxRate": 0
        },
        {
            "code": "JP-27",
            "name": "Ōsaka",
            "taxRate": 0
        },
        {
            "code": "JP-41",
            "name": "Saga",
            "taxRate": 0
        },
        {
            "code": "JP-11",
            "name": "Saitama",
            "taxRate": 0
        },
        {
            "code": "JP-25",
            "name": "Shiga",
            "taxRate": 0
        },
        {
            "code": "JP-32",
            "name": "Shimane",
            "taxRate": 0
        },
        {
            "code": "JP-22",
            "name": "Shizuoka",
            "taxRate": 0
        },
        {
            "code": "JP-09",
            "name": "Tochigi",
            "taxRate": 0
        },
        {
            "code": "JP-36",
            "name": "Tokushima",
            "taxRate": 0
        },
        {
            "code": "JP-13",
            "name": "Tōkyō",
            "taxRate": 0
        },
        {
            "code": "JP-31",
            "name": "Tottori",
            "taxRate": 0
        },
        {
            "code": "JP-16",
            "name": "Toyama",
            "taxRate": 0
        },
        {
            "code": "JP-30",
            "name": "Wakayama",
            "taxRate": 0
        },
        {
            "code": "JP-06",
            "name": "Yamagata",
            "taxRate": 0
        },
        {
            "code": "JP-35",
            "name": "Yamaguchi",
            "taxRate": 0
        },
        {
            "code": "JP-19",
            "name": "Yamanashi",
            "taxRate": 0
        }
    ],
    "MY": [
        {
            "code": "JHR",
            "name": "Johor",
            "taxRate": 0
        },
        {
            "code": "KDH",
            "name": "Kedah",
            "taxRate": 0
        },
        {
            "code": "KTN",
            "name": "Kelantan",
            "taxRate": 0
        },
        {
            "code": "KUL",
            "name": "Kuala Lumpur",
            "taxRate": 0
        },
        {
            "code": "LBN",
            "name": "Labuan",
            "taxRate": 0
        },
        {
            "code": "MLK",
            "name": "Melaka",
            "taxRate": 0
        },
        {
            "code": "NSN",
            "name": "Negeri Sembilan",
            "taxRate": 0
        },
        {
            "code": "PHG",
            "name": "Pahang",
            "taxRate": 0
        },
        {
            "code": "PNG",
            "name": "Penang",
            "taxRate": 0
        },
        {
            "code": "PRK",
            "name": "Perak",
            "taxRate": 0
        },
        {
            "code": "PLS",
            "name": "Perlis",
            "taxRate": 0
        },
        {
            "code": "PJY",
            "name": "Putrajaya",
            "taxRate": 0
        },
        {
            "code": "SBH",
            "name": "Sabah",
            "taxRate": 0
        },
        {
            "code": "SWK",
            "name": "Sarawak",
            "taxRate": 0
        },
        {
            "code": "SGR",
            "name": "Selangor",
            "taxRate": 0
        },
        {
            "code": "TRG",
            "name": "Terengganu",
            "taxRate": 0
        }
    ],
    "NZ": [
        {
            "code": "AUK",
            "name": "Auckland",
            "taxRate": 0
        },
        {
            "code": "BOP",
            "name": "Bay of Plenty",
            "taxRate": 0
        },
        {
            "code": "CAN",
            "name": "Canterbury",
            "taxRate": 0
        },
        {
            "code": "CIT",
            "name": "Chatham Islands",
            "taxRate": 0
        },
        {
            "code": "GIS",
            "name": "Gisborne",
            "taxRate": 0
        },
        {
            "code": "HKB",
            "name": "Hawke's Bay",
            "taxRate": 0
        },
        {
            "code": "MWT",
            "name": "Manawatu-Wanganui",
            "taxRate": 0
        },
        {
            "code": "MBH",
            "name": "Marlborough",
            "taxRate": 0
        },
        {
            "code": "NSN",
            "name": "Nelson",
            "taxRate": 0
        },
        {
            "code": "NTL",
            "name": "Northland",
            "taxRate": 0
        },
        {
            "code": "OTA",
            "name": "Otago",
            "taxRate": 0
        },
        {
            "code": "STL",
            "name": "Southland",
            "taxRate": 0
        },
        {
            "code": "TKI",
            "name": "Taranaki",
            "taxRate": 0
        },
        {
            "code": "TAS",
            "name": "Tasman",
            "taxRate": 0
        },
        {
            "code": "WKO",
            "name": "Waikato",
            "taxRate": 0
        },
        {
            "code": "WGN",
            "name": "Wellington",
            "taxRate": 0
        },
        {
            "code": "WTC",
            "name": "West Coast",
            "taxRate": 0
        }
    ],
    "PT": [
        {
            "code": "PT-20",
            "name": "Açores",
            "taxRate": 0
        },
        {
            "code": "PT-01",
            "name": "Aveiro",
            "taxRate": 0
        },
        {
            "code": "PT-02",
            "name": "Beja",
            "taxRate": 0
        },
        {
            "code": "PT-03",
            "name": "Braga",
            "taxRate": 0
        },
        {
            "code": "PT-04",
            "name": "Bragança",
            "taxRate": 0
        },
        {
            "code": "PT-05",
            "name": "Castelo Branco",
            "taxRate": 0
        },
        {
            "code": "PT-06",
            "name": "Coimbra",
            "taxRate": 0
        },
        {
            "code": "PT-07",
            "name": "Évora",
            "taxRate": 0
        },
        {
            "code": "PT-08",
            "name": "Faro",
            "taxRate": 0
        },
        {
            "code": "PT-09",
            "name": "Guarda",
            "taxRate": 0
        },
        {
            "code": "PT-10",
            "name": "Leiria",
            "taxRate": 0
        },
        {
            "code": "PT-11",
            "name": "Lisboa",
            "taxRate": 0
        },
        {
            "code": "PT-30",
            "name": "Madeira",
            "taxRate": 0
        },
        {
            "code": "PT-12",
            "name": "Portalegre",
            "taxRate": 0
        },
        {
            "code": "PT-13",
            "name": "Porto",
            "taxRate": 0
        },
        {
            "code": "PT-14",
            "name": "Santarém",
            "taxRate": 0
        },
        {
            "code": "PT-15",
            "name": "Setúbal",
            "taxRate": 0
        },
        {
            "code": "PT-16",
            "name": "Viana do Castelo",
            "taxRate": 0
        },
        {
            "code": "PT-17",
            "name": "Vila Real",
            "taxRate": 0
        },
        {
            "code": "PT-18",
            "name": "Viseu",
            "taxRate": 0
        }
    ],
    "RO": [
        {
            "code": "AB",
            "name": "Alba",
            "taxRate": 0
        },
        {
            "code": "AR",
            "name": "Arad",
            "taxRate": 0
        },
        {
            "code": "AG",
            "name": "Argeș",
            "taxRate": 0
        },
        {
            "code": "BC",
            "name": "Bacău",
            "taxRate": 0
        },
        {
            "code": "BH",
            "name": "Bihor",
            "taxRate": 0
        },
        {
            "code": "BN",
            "name": "Bistrița-Năsăud",
            "taxRate": 0
        },
        {
            "code": "BT",
            "name": "Botoșani",
            "taxRate": 0
        },
        {
            "code": "BR",
            "name": "Brăila",
            "taxRate": 0
        },
        {
            "code": "BV",
            "name": "Brașov",
            "taxRate": 0
        },
        {
            "code": "B",
            "name": "București",
            "taxRate": 0
        },
        {
            "code": "BZ",
            "name": "Buzău",
            "taxRate": 0
        },
        {
            "code": "CL",
            "name": "Călărași",
            "taxRate": 0
        },
        {
            "code": "CS",
            "name": "Caraș-Severin",
            "taxRate": 0
        },
        {
            "code": "CJ",
            "name": "Cluj",
            "taxRate": 0
        },
        {
            "code": "CT",
            "name": "Constanța",
            "taxRate": 0
        },
        {
            "code": "CV",
            "name": "Covasna",
            "taxRate": 0
        },
        {
            "code": "DB",
            "name": "Dâmbovița",
            "taxRate": 0
        },
        {
            "code": "DJ",
            "name": "Dolj",
            "taxRate": 0
        },
        {
            "code": "GL",
            "name": "Galați",
            "taxRate": 0
        },
        {
            "code": "GR",
            "name": "Giurgiu",
            "taxRate": 0
        },
        {
            "code": "GJ",
            "name": "Gorj",
            "taxRate": 0
        },
        {
            "code": "HR",
            "name": "Harghita",
            "taxRate": 0
        },
        {
            "code": "HD",
            "name": "Hunedoara",
            "taxRate": 0
        },
        {
            "code": "IL",
            "name": "Ialomița",
            "taxRate": 0
        },
        {
            "code": "IS",
            "name": "Iași",
            "taxRate": 0
        },
        {
            "code": "IF",
            "name": "Ilfov",
            "taxRate": 0
        },
        {
            "code": "MM",
            "name": "Maramureș",
            "taxRate": 0
        },
        {
            "code": "MH",
            "name": "Mehedinți",
            "taxRate": 0
        },
        {
            "code": "MS",
            "name": "Mureș",
            "taxRate": 0
        },
        {
            "code": "NT",
            "name": "Neamț",
            "taxRate": 0
        },
        {
            "code": "OT",
            "name": "Olt",
            "taxRate": 0
        },
        {
            "code": "PH",
            "name": "Prahova",
            "taxRate": 0
        },
        {
            "code": "SJ",
            "name": "Sălaj",
            "taxRate": 0
        },
        {
            "code": "SM",
            "name": "Satu Mare",
            "taxRate": 0
        },
        {
            "code": "SB",
            "name": "Sibiu",
            "taxRate": 0
        },
        {
            "code": "SV",
            "name": "Suceava",
            "taxRate": 0
        },
        {
            "code": "TR",
            "name": "Teleorman",
            "taxRate": 0
        },
        {
            "code": "TM",
            "name": "Timiș",
            "taxRate": 0
        },
        {
            "code": "TL",
            "name": "Tulcea",
            "taxRate": 0
        },
        {
            "code": "VL",
            "name": "Vâlcea",
            "taxRate": 0
        },
        {
            "code": "VS",
            "name": "Vaslui",
            "taxRate": 0
        },
        {
            "code": "VN",
            "name": "Vrancea",
            "taxRate": 0
        }
    ],
    "ZA": [
        {
            "code": "EC",
            "name": "Eastern Cape",
            "taxRate": 0
        },
        {
            "code": "FS",
            "name": "Free State",
            "taxRate": 0
        },
        {
            "code": "GP",
            "name": "Gauteng",
            "taxRate": 0
        },
        {
            "code": "NL",
            "name": "KwaZulu-Natal",
            "taxRate": 0
        },
        {
            "code": "LP",
            "name": "Limpopo",
            "taxRate": 0
        },
        {
            "code": "MP",
            "name": "Mpumalanga",
            "taxRate": 0
        },
        {
            "code": "NW",
            "name": "North West",
            "taxRate": 0
        },
        {
            "code": "NC",
            "name": "Northern Cape",
            "taxRate": 0
        },
        {
            "code": "WC",
            "name": "Western Cape",
            "taxRate": 0
        }
    ],
    "KR": [
        {
            "code": "KR-26",
            "name": "Busan",
            "taxRate": 0
        },
        {
            "code": "KR-43",
            "name": "Chungbuk",
            "taxRate": 0
        },
        {
            "code": "KR-44",
            "name": "Chungnam",
            "taxRate": 0
        },
        {
            "code": "KR-27",
            "name": "Daegu",
            "taxRate": 0
        },
        {
            "code": "KR-30",
            "name": "Daejeon",
            "taxRate": 0
        },
        {
            "code": "KR-42",
            "name": "Gangwon",
            "taxRate": 0
        },
        {
            "code": "KR-29",
            "name": "Gwangju",
            "taxRate": 0
        },
        {
            "code": "KR-47",
            "name": "Gyeongbuk",
            "taxRate": 0
        },
        {
            "code": "KR-41",
            "name": "Gyeonggi",
            "taxRate": 0
        },
        {
            "code": "KR-48",
            "name": "Gyeongnam",
            "taxRate": 0
        },
        {
            "code": "KR-28",
            "name": "Incheon",
            "taxRate": 0
        },
        {
            "code": "KR-49",
            "name": "Jeju",
            "taxRate": 0
        },
        {
            "code": "KR-45",
            "name": "Jeonbuk",
            "taxRate": 0
        },
        {
            "code": "KR-46",
            "name": "Jeonnam",
            "taxRate": 0
        },
        {
            "code": "KR-50",
            "name": "Sejong",
            "taxRate": 0
        },
        {
            "code": "KR-11",
            "name": "Seoul",
            "taxRate": 0
        },
        {
            "code": "KR-31",
            "name": "Ulsan",
            "taxRate": 0
        }
    ],
    "ES": [
        {
            "code": "C",
            "name": "A Coruña",
            "taxRate": 0
        },
        {
            "code": "VI",
            "name": "Álava",
            "taxRate": 0
        },
        {
            "code": "AB",
            "name": "Albacete",
            "taxRate": 0
        },
        {
            "code": "A",
            "name": "Alicante",
            "taxRate": 0
        },
        {
            "code": "AL",
            "name": "Almería",
            "taxRate": 0
        },
        {
            "code": "O",
            "name": "Asturias",
            "taxRate": 0
        },
        {
            "code": "AV",
            "name": "Ávila",
            "taxRate": 0
        },
        {
            "code": "BA",
            "name": "Badajoz",
            "taxRate": 0
        },
        {
            "code": "PM",
            "name": "Balears",
            "taxRate": 0
        },
        {
            "code": "B",
            "name": "Barcelona",
            "taxRate": 0
        },
        {
            "code": "BU",
            "name": "Burgos",
            "taxRate": 0
        },
        {
            "code": "CC",
            "name": "Cáceres",
            "taxRate": 0
        },
        {
            "code": "CA",
            "name": "Cádiz",
            "taxRate": 0
        },
        {
            "code": "S",
            "name": "Cantabria",
            "taxRate": 0
        },
        {
            "code": "CS",
            "name": "Castellón",
            "taxRate": 0
        },
        {
            "code": "CE",
            "name": "Ceuta",
            "taxRate": 0
        },
        {
            "code": "CR",
            "name": "Ciudad Real",
            "taxRate": 0
        },
        {
            "code": "CO",
            "name": "Córdoba",
            "taxRate": 0
        },
        {
            "code": "CU",
            "name": "Cuenca",
            "taxRate": 0
        },
        {
            "code": "GI",
            "name": "Girona",
            "taxRate": 0
        },
        {
            "code": "GR",
            "name": "Granada",
            "taxRate": 0
        },
        {
            "code": "GU",
            "name": "Guadalajara",
            "taxRate": 0
        },
        {
            "code": "SS",
            "name": "Guipúzcoa",
            "taxRate": 0
        },
        {
            "code": "H",
            "name": "Huelva",
            "taxRate": 0
        },
        {
            "code": "HU",
            "name": "Huesca",
            "taxRate": 0
        },
        {
            "code": "J",
            "name": "Jaén",
            "taxRate": 0
        },
        {
            "code": "LO",
            "name": "La Rioja",
            "taxRate": 0
        },
        {
            "code": "GC",
            "name": "Las Palmas",
            "taxRate": 0
        },
        {
            "code": "LE",
            "name": "León",
            "taxRate": 0
        },
        {
            "code": "L",
            "name": "Lleida",
            "taxRate": 0
        },
        {
            "code": "LU",
            "name": "Lugo",
            "taxRate": 0
        },
        {
            "code": "M",
            "name": "Madrid",
            "taxRate": 0
        },
        {
            "code": "MA",
            "name": "Málaga",
            "taxRate": 0
        },
        {
            "code": "ML",
            "name": "Melilla",
            "taxRate": 0
        },
        {
            "code": "MU",
            "name": "Murcia",
            "taxRate": 0
        },
        {
            "code": "NA",
            "name": "Navarra",
            "taxRate": 0
        },
        {
            "code": "OR",
            "name": "Ourense",
            "taxRate": 0
        },
        {
            "code": "P",
            "name": "Palencia",
            "taxRate": 0
        },
        {
            "code": "PO",
            "name": "Pontevedra",
            "taxRate": 0
        },
        {
            "code": "SA",
            "name": "Salamanca",
            "taxRate": 0
        },
        {
            "code": "TF",
            "name": "Santa Cruz de Tenerife",
            "taxRate": 0
        },
        {
            "code": "SG",
            "name": "Segovia",
            "taxRate": 0
        },
        {
            "code": "SE",
            "name": "Sevilla",
            "taxRate": 0
        },
        {
            "code": "SO",
            "name": "Soria",
            "taxRate": 0
        },
        {
            "code": "T",
            "name": "Tarragona",
            "taxRate": 0
        },
        {
            "code": "TE",
            "name": "Teruel",
            "taxRate": 0
        },
        {
            "code": "TO",
            "name": "Toledo",
            "taxRate": 0
        },
        {
            "code": "V",
            "name": "Valencia",
            "taxRate": 0
        },
        {
            "code": "VA",
            "name": "Valladolid",
            "taxRate": 0
        },
        {
            "code": "BI",
            "name": "Vizcaya",
            "taxRate": 0
        },
        {
            "code": "ZA",
            "name": "Zamora",
            "taxRate": 0
        },
        {
            "code": "Z",
            "name": "Zaragoza",
            "taxRate": 0
        }
    ],
    "AE": [
        {
            "code": "AZ",
            "name": "Abu Dhabi",
            "taxRate": 0
        },
        {
            "code": "AJ",
            "name": "Ajman",
            "taxRate": 0
        },
        {
            "code": "DU",
            "name": "Dubai",
            "taxRate": 0
        },
        {
            "code": "FU",
            "name": "Fujairah",
            "taxRate": 0
        },
        {
            "code": "RK",
            "name": "Ras al-Khaimah",
            "taxRate": 0
        },
        {
            "code": "SH",
            "name": "Sharjah",
            "taxRate": 0
        },
        {
            "code": "UQ",
            "name": "Umm al-Quwain",
            "taxRate": 0
        }
    ],
    "GB": [
        {
            "code": "BFP",
            "name": "British Forces",
            "taxRate": 0
        },
        {
            "code": "ENG",
            "name": "England",
            "taxRate": 0
        },
        {
            "code": "NIR",
            "name": "Northern Ireland",
            "taxRate": 0
        },
        {
            "code": "SCT",
            "name": "Scotland",
            "taxRate": 0
        },
        {
            "code": "WLS",
            "name": "Wales",
            "taxRate": 0
        }
    ],
    "US": [
        {
            "code": "AL",
            "name": "Alabama",
            "taxRate": 0
        },
        {
            "code": "AK",
            "name": "Alaska",
            "taxRate": 0
        },
        {
            "code": "AS",
            "name": "American Samoa",
            "taxRate": 0
        },
        {
            "code": "AZ",
            "name": "Arizona",
            "taxRate": 0
        },
        {
            "code": "AR",
            "name": "Arkansas",
            "taxRate": 0
        },
        {
            "code": "AA",
            "name": "Armed Forces Americas",
            "taxRate": 0
        },
        {
            "code": "AE",
            "name": "Armed Forces Europe",
            "taxRate": 0
        },
        {
            "code": "AP",
            "name": "Armed Forces Pacific",
            "taxRate": 0
        },
        {
            "code": "CA",
            "name": "California",
            "taxRate": 0
        },
        {
            "code": "CO",
            "name": "Colorado",
            "taxRate": 0
        },
        {
            "code": "CT",
            "name": "Connecticut",
            "taxRate": 0
        },
        {
            "code": "DE",
            "name": "Delaware",
            "taxRate": 0
        },
        {
            "code": "DC",
            "name": "District of Columbia",
            "taxRate": 0
        },
        {
            "code": "FM",
            "name": "Federated States of Micronesia",
            "taxRate": 0
        },
        {
            "code": "FL",
            "name": "Florida",
            "taxRate": 0
        },
        {
            "code": "GA",
            "name": "Georgia",
            "taxRate": 0
        },
        {
            "code": "GU",
            "name": "Guam",
            "taxRate": 0
        },
        {
            "code": "HI",
            "name": "Hawaii",
            "taxRate": 0
        },
        {
            "code": "ID",
            "name": "Idaho",
            "taxRate": 0
        },
        {
            "code": "IL",
            "name": "Illinois",
            "taxRate": 0
        },
        {
            "code": "IN",
            "name": "Indiana",
            "taxRate": 0
        },
        {
            "code": "IA",
            "name": "Iowa",
            "taxRate": 0
        },
        {
            "code": "KS",
            "name": "Kansas",
            "taxRate": 0
        },
        {
            "code": "KY",
            "name": "Kentucky",
            "taxRate": 0
        },
        {
            "code": "LA",
            "name": "Louisiana",
            "taxRate": 0
        },
        {
            "code": "ME",
            "name": "Maine",
            "taxRate": 0
        },
        {
            "code": "MH",
            "name": "Marshall Islands",
            "taxRate": 0
        },
        {
            "code": "MD",
            "name": "Maryland",
            "taxRate": 0
        },
        {
            "code": "MA",
            "name": "Massachusetts",
            "taxRate": 0
        },
        {
            "code": "MI",
            "name": "Michigan",
            "taxRate": 0
        },
        {
            "code": "MN",
            "name": "Minnesota",
            "taxRate": 0
        },
        {
            "code": "MS",
            "name": "Mississippi",
            "taxRate": 0
        },
        {
            "code": "MO",
            "name": "Missouri",
            "taxRate": 0
        },
        {
            "code": "MT",
            "name": "Montana",
            "taxRate": 0
        },
        {
            "code": "NE",
            "name": "Nebraska",
            "taxRate": 0
        },
        {
            "code": "NV",
            "name": "Nevada",
            "taxRate": 0
        },
        {
            "code": "NH",
            "name": "New Hampshire",
            "taxRate": 0
        },
        {
            "code": "NJ",
            "name": "New Jersey",
            "taxRate": 0
        },
        {
            "code": "NM",
            "name": "New Mexico",
            "taxRate": 0
        },
        {
            "code": "NY",
            "name": "New York",
            "taxRate": 0
        },
        {
            "code": "NC",
            "name": "North Carolina",
            "taxRate": 0
        },
        {
            "code": "ND",
            "name": "North Dakota",
            "taxRate": 0
        },
        {
            "code": "MP",
            "name": "Northern Mariana Islands",
            "taxRate": 0
        },
        {
            "code": "OH",
            "name": "Ohio",
            "taxRate": 0
        },
        {
            "code": "OK",
            "name": "Oklahoma",
            "taxRate": 0
        },
        {
            "code": "OR",
            "name": "Oregon",
            "taxRate": 0
        },
        {
            "code": "PW",
            "name": "Palau",
            "taxRate": 0
        },
        {
            "code": "PA",
            "name": "Pennsylvania",
            "taxRate": 0
        },
        {
            "code": "PR",
            "name": "Puerto Rico",
            "taxRate": 0
        },
        {
            "code": "RI",
            "name": "Rhode Island",
            "taxRate": 0
        },
        {
            "code": "SC",
            "name": "South Carolina",
            "taxRate": 0
        },
        {
            "code": "SD",
            "name": "South Dakota",
            "taxRate": 0
        },
        {
            "code": "TN",
            "name": "Tennessee",
            "taxRate": 0
        },
        {
            "code": "TX",
            "name": "Texas",
            "taxRate": 0
        },
        {
            "code": "UT",
            "name": "Utah",
            "taxRate": 0
        },
        {
            "code": "VT",
            "name": "Vermont",
            "taxRate": 0
        },
        {
            "code": "VI",
            "name": "Virgin Islands",
            "taxRate": 0
        },
        {
            "code": "VA",
            "name": "Virginia",
            "taxRate": 0
        },
        {
            "code": "WA",
            "name": "Washington",
            "taxRate": 0
        },
        {
            "code": "WV",
            "name": "West Virginia",
            "taxRate": 0
        },
        {
            "code": "WI",
            "name": "Wisconsin",
            "taxRate": 0
        },
        {
            "code": "WY",
            "name": "Wyoming",
            "taxRate": 0
        }
    ]
};
